import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    fetchRankingsData,
} from '../../../actions/top-ranked-actions';

import TabTable from '../TabTable';
import Tabs from '../Tabs';
import { LinkAnchor } from '../../Links';
import RankedPlayerItem from '../RankingListV2/components/RankedPlayerItem';

import { marketingAppHost } from '../../../../config';
import { GLOBAL_PLAYER_RANKINGS_TITLE, TABS_GENDER, DEFAULT_FILTERS, GENDER_MALE } from '../../../utils/constants';
import styles from './style.module.scss';

const tabs = [
    {
        name: 'U14',
        value: 'U14',
    },
    {
        name: 'U16',
        value: 'U16',
    },
    {
        name: 'U18',
        value: 'U18',
    },
    {
        name: 'HIGH SCHOOL',
        value: 'HighSchool',
    },
    {
        name: 'COLLEGE',
        value: 'College',
    },
    {
        name: 'PRO',
        value: 'Pro',
        default: true,
    },
];

const GlobalRankings = (props) => {
    const { menPlayers, womenPlayers, className, displayCount, history, auth, 'data-testid': dataTestId, ...restProps } = props;
    const handleTableChange = (tableData) => {
        props.fetchRankingsData({
            tags: tableData.level,
            count: displayCount,
        });
    };

    const handleShowAllRedirect = () => {
        window.open(`${marketingAppHost}/pages/rankings`, '_blank');
    };

    const showTennisContent = auth?.feedPreferences?.showTennisContent;

    if (!!showTennisContent) {
        return (
            <div className={`${styles.container} ${className}`}>
                <TabTable
                    title={GLOBAL_PLAYER_RANKINGS_TITLE}
                    handleViewAllClick={handleShowAllRedirect}
                    callBack={handleTableChange}
                    defaultFilters={DEFAULT_FILTERS}
                    list={({ filters }) => (filters.gender === GENDER_MALE ? menPlayers : womenPlayers).slice(0, displayCount)}
                    renderTabs={({ filters, handleFilterChange }) => (
                        <div className={styles.tabsContainer}>
                            <Tabs
                                tabs={tabs}
                                onTabChange={(val) => handleFilterChange('level', val)}
                                activeTab={filters.level}
                            />
                            <span className={styles.divider}>|</span>
                            <Tabs
                                tabs={TABS_GENDER}
                                tabHeaderClass="ml16"
                                onTabChange={(val) => handleFilterChange('gender', val)}
                                activeTab={filters.gender}
                            />
                        </div>
                    )}
                    listItem={({ item, isLoading }) => (
                        <div className={styles.listItemContainer}>
                            <LinkAnchor
                                link={`app:/profiles/${item.id}`}
                                key={item.id}
                                data-testid={dataTestId && `${dataTestId}.player-${item.id}`}
                            >
                                <RankedPlayerItem
                                    {...item}
                                    ranking={item.utrRanking}
                                    rating={item.utr}
                                    loading={isLoading}
                                />
                            </LinkAnchor>
                        </div>
                    )}
                    {...restProps}
                />
            </div>
        );
    }
    return null;
};

GlobalRankings.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    fetchRankingsData: PropTypes.func.isRequired,
    menPlayers: PropTypes.instanceOf(Array),
    womenPlayers: PropTypes.instanceOf(Array),
    isLoading: PropTypes.bool.isRequired,
};

GlobalRankings.defaultProps = {
    menPlayers: [],
    womenPlayers: [],
};

const mapStateToProps = ({
    topPlayers: {
        men: { isLoading: menLoading, players: menPlayers },
        women: { isLoading: womenLoading, players: womenPlayers },
    },
}) => ({
    isLoading: menLoading || womenLoading,
    menPlayers,
    womenPlayers,
});

const mapDispatchToProps = {
    fetchRankingsData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GlobalRankings));
